function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "140",
  height: "190"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_5",
  "data-name": "New Gradient Swatch 5",
  x1: "55.08",
  y1: "-5.92",
  x2: "215.77",
  y2: "154.77",
  gradientTransform: "matrix(-1 0 0 1 184 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_5-2",
  x1: "-23.82",
  y1: "24.68",
  x2: "142.94",
  y2: "191.44",
  xlinkHref: "#New_Gradient_Swatch_5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_5-3",
  x1: "9.93",
  y1: "-8.28",
  x2: "175.98",
  y2: "157.77",
  xlinkHref: "#New_Gradient_Swatch_5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_5-4",
  x1: "73.45",
  y1: "-50.55",
  x2: "275.08",
  y2: "151.08",
  xlinkHref: "#New_Gradient_Swatch_5"
})), /*#__PURE__*/React.createElement("title", null, "graphic_spot_name-badge"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#New_Gradient_Swatch_5)",
  d: "M77 43H63l63-43h14L77 43z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".25",
  d: "M77 43H63l63-43h14L77 43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112 47H28a8 8 0 00-8 8v127a8 8 0 008 8h84a8 8 0 008-8V55a8 8 0 00-8-8zM85 59a2.17 2.17 0 01-2.31 2H57.31A2.17 2.17 0 0155 59v-2a2.17 2.17 0 012.31-2h25.38A2.17 2.17 0 0185 57z",
  fill: "url(#New_Gradient_Swatch_5-2)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30",
  y: "135",
  width: "80",
  height: "8",
  rx: "1.62",
  ry: "1.62",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".25"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30",
  y: "151",
  width: "80",
  height: "4",
  rx: "1",
  ry: "1",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".25"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30",
  y: "163",
  width: "80",
  height: "4",
  rx: "1",
  ry: "1",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 43h16a2 2 0 012 2v14a1 1 0 01-1 1H61a1 1 0 01-1-1V45a2 2 0 012-2z",
  fill: "url(#New_Gradient_Swatch_5-3)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#193138"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 99a29.78 29.78 0 01-8.32 20.7l-.32.32a29.93 29.93 0 01-42.73 0c-.09-.11-.21-.22-.32-.33A30 30 0 11100 99z",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".25"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "70",
  cy: "87.55",
  r: "12.24",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.36 120a29.93 29.93 0 01-42.73 0 21.7 21.7 0 0142.73 0z",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".25"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#New_Gradient_Swatch_5-4)",
  d: "M63 43h14L14 0H0l63 43z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2",
  d: "M80 47h2v8h-2z"
})))));